import React, { useState, useEffect, useRef } from 'react';
import Layout from '../../../../common/Layout';
import LoadingAnimation from "../../../../common/components/base/LoadingAnimation";
import ChallengePanel from '../../ChallengePanel';
import LineItemsSimulation from "../LineItemsSimulation";
import { useChallenge } from '../../../../hooks/useChallenge';
import { useChallengeInstance } from '../../../../hooks/useChallengeInstance';
import { useEvaluateStep } from '../../../../hooks/useEvaluateStep';
import { useNavigate, useParams } from 'react-router-dom';
import { campaignVar, creativesVar, creativeVar, deliveryVar, frequencyCAPVar, lineItemsVar, lineItemVar, recencyVar, typeVar } from '../../../../settings/cache';

const ReportAdServerStep5 = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const evaluateStepMutation = useEvaluateStep();

  const [stepTime, setStepTime] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setStepTime(prevTime => prevTime + 1);
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  const [lineItems] = useState([
      {
        "name":"skinius_lineitem_thissummer_banner_300x250",
        "lineitemID":"LI10002",
        "type":"Standard campaign",
        "scheduleDuration":"168",
        "status":"Active",
        "budgetPlanned":"1500",
        "impressionsPlanned":"3000000",
        "cpm":"0,50",
        "impressionsDelivered":"1290000",
        "budgetDelivered":"645",
        "clicks":"6450",
        "conversions":"580",
        "placement":"PL109",
        "delivery":"ASAP",
        "frequency":"3",
        "recency":"24",
        "creatives": [
          {
            "adsName": "skinius_thissummer_banner_300x250",
            "url": "skinius.it",
            "creative": "skinius.it_300x250_banner",
            "adStatus": "Active",
            "__typename" : "Creative"
          }
        ]
    },
    {
        "name":"skinius_lineitem_thissummer_banner02_300x250",
        "lineitemID":"LI10003",
        "type":"Standard campaign",
        "scheduleDuration":"168",
        "status":"Active",
        "budgetPlanned":"1320",
        "impressionsPlanned":"6000000",
        "cpm":"0,22",
        "impressionsDelivered":"710000",
        "budgetDelivered":"355",
        "clicks":"1442",
        "conversions":"170",
        "placement":"PL103",
        "delivery":"ASAP",
        "frequency":"1",
        "recency":"48",
        "creatives":  [
          {
            "adsName": "skinius_thissummer_banner02_300x250",
            "url": "skinius.it",
            "creative": "skinius.it_300x250_banner",
            "adStatus": "Active"
          }
        ]
    }
  ]);

  const [name] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    campaignVar({});
    creativesVar([]);
    creativeVar({});
    lineItemsVar([]);
    lineItemVar({});
  }, []);

  const { data: challengeInstanceData, isLoading: isLoadingInstance } = useChallengeInstance(id);
  const challengeType = challengeInstanceData?.challengeType;
  const currentStep = challengeInstanceData?.currentStep;

  const { data: challengeData, isLoading: isLoadingChallenge } = useChallenge(challengeType, {
    enabled: !!challengeType
  });

  const handleTab = () => {
    // Empty handler
  };

  const submit = async () => {
    setIsSubmitting(true);
    
    const action = {
      actionNeeded: 'complete',
      target: JSON.stringify({
        type: "lineitem",
        fields: {
          "lineitemType": typeVar(),
          "deliveryType": deliveryVar(),
          "frequency": frequencyCAPVar(),
          "recency": recencyVar()
        }
      }),
      stepTime
    };

    try {
      const res = await evaluateStepMutation.mutateAsync({
        id,
        action
      });

      if (res && res !== '') {
        navigate(res + id);
      }
    } catch (error) {
      console.error('Error evaluating step:', error);
      setIsSubmitting(false);
    }
  };

  if (isLoadingInstance || isLoadingChallenge || !challengeType) {
    return <LoadingAnimation />;
  }

  if (!challengeData) {
    return <div>No data available</div>;
  }

  const step = parseInt(currentStep);
  const StepCountDownTime = challengeData.steps[5]?.countdownTime;

  return (
    <Layout name="Campaigns">
      <div className="wizard-container">
        <div className="col-md-12 col-12 mr-auto ml-auto">
          <div className="card card-wizard active" data-color="rose" id="wizardProfile">
            <div>
              <div>
                <LineItemsSimulation
                  handleTab={handleTab}
                  caption="Line Items"
                  submit={submit}
                  name={name}
                  id={id}
                  items={lineItems}
                  lineItemsLength={lineItems.length}
                  isSubmitting={isSubmitting}
                />
                <ChallengePanel
                  time={StepCountDownTime}
                  description={challengeData.challengeDescription}
                  coach={challengeData.coach}
                  challengeTitle={challengeData.challengeTitle}
                  challengeIsValidation={challengeData.isValidation}
                  challengeDifficulty={challengeData.challengeDifficulty}
                  challengeAverageTime={challengeData.challengeAverageTime}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ReportAdServerStep5;

